//@ts-check
import AccessDetailsTab from './AccessDetailsTab';

export default AccessDetailsTab;
